@if (openBox) {
  <div class="ab-backdrop" (click)="closeBox()">
    <div
      class="ab-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="ab-title"
      (click)="$event.stopPropagation()"
    >
      <!-- Header -->
      <header class="ab-header">
        <div class="ab-title-block">
          <h2 id="ab-title">📦 Aggiungi una scatola</h2>
          <p class="ab-subtitle">Scegli il tipo e il numero di colli</p>
        </div>
        <button
          type="button"
          class="ab-close"
          aria-label="Chiudi"
          (click)="closeBox()"
        >
          ×
        </button>
      </header>

      <!-- Body -->
      <div class="ab-body">
        <!-- Scatola standard -->
        <section class="ab-section">
          <h3 class="ab-section-title">
            <i class="bx bx-package"></i> Scatola standard
          </h3>

          @if (boxes.length === 0) {
            <p class="ab-empty">Nessuna scatola standard disponibile.</p>
          } @else {
            <div class="ab-options" role="radiogroup">
              @for (box of boxes; track box.box_type_id; let i = $index) {
                <label
                  class="ab-option"
                  [class.ab-option--selected]="isSelected(box.box_type_id)"
                >
                  <input
                    type="radio"
                    name="ab-box-choice"
                    [value]="box.box_type_id"
                    [checked]="isSelected(box.box_type_id)"
                    (change)="changeBox(box.box_type_id, box.box_type_desc)"
                  />
                  <span class="ab-option-label">{{ box.box_type_desc }}</span>
                  @if (isSelected(box.box_type_id)) {
                    <i class="bx bxs-check-circle ab-option-check"></i>
                  }
                </label>
              }
            </div>
          }
        </section>

        <!-- Scatola custom -->
        <section class="ab-section">
          <h3 class="ab-section-title">
            <i class="bx bx-cube"></i> Scatola custom
          </h3>

          <label
            class="ab-option ab-option--custom"
            [class.ab-option--selected]="isSelected(-1)"
          >
            <input
              type="radio"
              name="ab-box-choice"
              [value]="-1"
              [checked]="isSelected(-1)"
              (change)="changeBox(-1, 'Custom')"
            />
            <span class="ab-option-label">Dimensioni personalizzate</span>
            @if (isSelected(-1)) {
              <i class="bx bxs-check-circle ab-option-check"></i>
            }
          </label>

          @if (isSelected(-1)) {
            <div class="ab-custom-fields">
              <label class="ab-field">
                <span class="ab-field-label">Altezza (mm)</span>
                <input
                  type="number"
                  class="ab-field-input"
                  [(ngModel)]="newBox.ts_box_height"
                  min="0"
                  placeholder="0"
                />
              </label>
              <label class="ab-field">
                <span class="ab-field-label">Lunghezza (mm)</span>
                <input
                  type="number"
                  class="ab-field-input"
                  [(ngModel)]="newBox.ts_box_length"
                  min="0"
                  placeholder="0"
                />
              </label>
              <label class="ab-field">
                <span class="ab-field-label">Profondità (mm)</span>
                <input
                  type="number"
                  class="ab-field-input"
                  [(ngModel)]="newBox.ts_box_depth"
                  min="0"
                  placeholder="0"
                />
              </label>
              <label class="ab-field">
                <span class="ab-field-label">Peso (kg)</span>
                <input
                  type="number"
                  class="ab-field-input"
                  [(ngModel)]="newBox.ts_box_weight"
                  min="0"
                  step="0.01"
                  placeholder="0"
                />
              </label>
            </div>
          }
        </section>

        <!-- Quantità -->
        <section class="ab-section">
          <h3 class="ab-section-title">
            <i class="bx bx-hash"></i> Numero di colli
          </h3>
          <label class="ab-field ab-field--qty">
            <span class="ab-field-label">Quantità</span>
            <select
              class="ab-field-input ab-select"
              [(ngModel)]="selectedNumber"
            >
              <option [ngValue]="0" disabled>Seleziona…</option>
              @for (n of numbers; track n) {
                <option [ngValue]="n">{{ n }}</option>
              }
            </select>
          </label>
        </section>
      </div>

      <!-- Footer -->
      <footer class="ab-footer">
        <button type="button" class="ab-btn ab-btn--cancel" (click)="closeBox()">
          <i class="bx bx-x"></i> Annulla
        </button>
        <button
          type="button"
          class="ab-btn ab-btn--save"
          [disabled]="isSaveDisabled"
          (click)="validateBox()"
        >
          <i class="bx bx-check-circle"></i> Salva
        </button>
      </footer>
    </div>
  </div>
}
